export function bypassSplash(path, storage) {
  if (/^\/research(?:\/|$)/.test(path)) return true;
  try { return storage.getItem("aeon_boot_seen") === "1"; } catch { return false; }
}

let prefetch;
export function prefetchResearch() {
  if (!prefetch) prefetch = fetch(`${process.env.REACT_APP_BACKEND_URL || ""}/api/research/editions/latest`).then(response => {
    if (!response.ok) throw new Error("Edition prefetch unavailable");
    return response.json();
  }).catch(() => null).finally(() => { prefetch = null; });
  return prefetch;
}
